import React from "react";
import Button from "../../../../../components/button/button.jsx";
import {Modal} from "../../../../../components/modal/modal.jsx";

const ScheduleAttendanceProcedureModal = ({
    open,
    content,
    onOpenChange,
    onCopy,
}) => (
    <Modal
        open={open}
        setOpen={onOpenChange}
        title="Modelo para preenchimento"
        className="w-7/12"
    >
        <Modal.Body className="max-h-[calc(100vh-180px)] overflow-auto">
            <div className="whitespace-pre-wrap border border-gray-200 rounded-md p-3 text-sm text-gray-600 max-h-[60vh] overflow-auto">
                {content}
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={onCopy}>Copiar</Button>
        </Modal.Footer>
    </Modal>
);

export default ScheduleAttendanceProcedureModal;
